import { createDirectus, graphql } from '@directus/sdk';

const CMS_URL = process.env.CMS_URL;

export type SceneToTourMap = Record<string, TourStep>;

function createSceneToTourMap(tour_steps?: TourStepCMS[]): SceneToTourMap[] | [] {
  if (!tour_steps) return [];
  return tour_steps.reduce((seceneToTourMap, tour_step) => {
    return {
      ...seceneToTourMap,
      [(tour_step?.scene?.id as string) || '']: {
        tourId: tour_step?.tour_id?.id || null,
        tourStepId: tour_step.id,
        stepNumber: tour_step.sort,
      },
    };
  }, []);
}

export type TourStep = {
  tourId: string;
  tourStepId: string;
  stepNumber: number;
};

interface TourStepCMS {
  id: string;
  sort: string;
  scene: {
    id: string;
  };
  tour_id: {
    id: string;
  };
}

interface GraphqlTourResult {
  tour_step: TourStepCMS[];

  tour: {
    id: string;
    translations: {
      title: string;
      languages_code: {
        code: string;
      };
    };
    steps: {
      id: string;
      sort: number;
      scene: {
        id: string;
        name: string;
      };
      translations: {
        title: string;
        tour_title: string;
        description: string;
        audio_description: string;
        languages_code: {
          code: string;
        };
      };
    };
  };
}
export const fetchTourData = async () => {
  if (!CMS_URL) {
    console.error('NO CMS_URL');
    return null;
  }
  const client = createDirectus(CMS_URL).with(graphql());

  const query = `
    query virtualTours {
      tour_step(filter: { active: { _eq: true }, scene: { id: { _null: false } } }) {
        id
          sort
          scene {
            id
          }
          tour_id {
            id
          }
        }
        tour (filter:{enabled:{_eq:true}}) {
          id
          translations {
            title
            description
            languages_code {
              code
            }
          }
          steps(sort: "sort", filter: { active: { _eq: true } }) {
            id
            sort
            scene {
              id
              name
            }
            translations {
              title
              tour_title
              description
              audio_description
              languages_code {
                code
              }
            }
          }
        }
      }

    `;

  const result = await client.query<GraphqlTourResult>(query);
  const tours = result.tour;
  const toursteps = createSceneToTourMap(result.tour_step);
  return { toursteps, tours };
};
